import { Star as StarIcon } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import React from "react";

export default (): JSX.Element => (
  <Tooltip title="This is a master debtor">
    <StarIcon style={{ color: "#f7bd5e", fontSize: "32px" }} />
  </Tooltip>
);
